import { Deposit } from '../types'

export type DepositsResponse = {
  data: { deposits: Deposit[] }
}

export type Args = {
  walletAddress: string
}

export const getQueryGraphDeposits = ({ walletAddress }: Args) => `{
  deposits(where: { depositor: "${walletAddress.toLowerCase()}" }) {
    id
    timestamp
    pool
    depositor {
      id
    }
    amount
    dtPrice
  }
}`
